<template lang="pug">
  CommonSection(title="Отделы" v-if="company && company.owner" :back="{ title: company.name, name: 'company-list', params: { companyId: $route.params.companyId } }")
    template(#title)
      HelpPopup(guide="https://teroom.ru/guides/76")
        template(#default)
          h2 Функционал «Компании»
          p Это структура бизнеса внутри платформы: компания, отделы, сотрудники, роли и должности.
          p Сотрудники приглашаются в общий список компании на странице «Сотрудники». Оттуда вы добавляете их в отделы и назначаете роли.
          p Логотип и данные компании — во вкладке «Настройки». Права участников — во вкладке «Права пользователей».
          p Внутри раздела «Компании» есть блок CRM, свой для каждой компании. Подробнее — на странице CRM.
    template(#button)
      .b-company-tile {{ company.name }}
        AvatarEditable._avatar(:editable="false" :avatar="company.avatar" placeholder="no-avatar-project")
      Btn(dark @click="addDepartment"  v-if="isOwner || isDeputy") Добавить отдел
    .b-company-department-list-page
      UserSelectPopup2(ref="userSelectPopup")
      ._header
        BaseInput._filter(label="Поиск" v-model="search")
      ._main
        DepartmentTile(v-for="department in departmentsFiltered" :key="department.id" :department="department")
      ._aside
</template>

<script>
import popupModel from '@/model/popup';
import model from '@/model/company';
import userModel from '@/model/user';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import UserSelectPopup2 from '@/components/UserSelectPopup2.vue';
import CompanyDepartmentFormPopupWrappable from '@/components/company/CompanyDepartmentFormPopupWrappable.vue';
import BaseInput from '@/components/BaseInput.vue';
import DepartmentTile from '@/components/company/DepartmentTile.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';
import HelpPopup from '@/components/base/HelpPopup.vue';

export default {
  name: 'CompanyDepartmentListPage',
  components: { AvatarEditable, DepartmentTile, CommonSection, DefaultLayout, UserSelectPopup2, BaseInput, HelpPopup },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    company() { return this.$store.getters['company/withMembers']; },
    employees() { return this.$store.state.company.employees ?? []; },
    deputies() { return this.company.deputies ?? [] },
    isOwner() { return this.company?.owner?.id === this.currUser.id },
    isDeputy() { return this.deputies.find(e => e.user.id === this.currUser.id) },
    departments() { return this.company?.departments ?? []; },
    departmentsFinal() {
      const mainDepartment = {
        id: 0,
        name: 'Отдел управления компанией',
        allDepartments: this.departments.map(d => d.id),
        members: [
          { '@id': 0, roleName: 'Руководитель', employee: { user: this.company.owner } },
          ...(this.company?.deputies ?? []).map(d => ({ '@type': 'Deputy', roleName: 'Заместитель руководителя', employee: d })),
        ],
      };

      return [mainDepartment, ...this.departments];
    },
    departmentsFiltered() {
      const prepare = str => str.toLowerCase().replace(/\s/g, '');
      const search = prepare(this.search);

      return this.departmentsFinal
        .map(d => ({ ...d, members: d.members.filter(m => prepare(m.employee.user.name + m.employee.user.surname).includes(search)) }))
        .filter(d => !search || d.members.length); // || prepare(d.name).includes(search));
    },
  },
  methods: {
    async addDepartment() {
      const data = await popupModel.add({
        wrappable: true,
        component: CompanyDepartmentFormPopupWrappable,
        params: {},
      });

      if (!data) return;

      await this.$store.dispatch('company/addDepartment', data);
      await userModel.fetchSelf();
    },
  },

};
</script>

<style lang="scss" scoped>

.company-tile {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 16px;
  margin-right: auto;

  &__avatar {
    width: 60px;
    height: 60px;
    border-width: 2px;
    border-radius: 16px;
    order: -1;
  }

  @media (max-width: 800px) {
    display: none;
  }
}

.company-department-list-page {
  &__header {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__filter {
    width: 300px;
    max-width: 100%
  }

  &__main {
    display: grid;
    gap: 38px;
  }
}

</style>
